import { useEffect, type ReactNode } from "react";
import { RemoteLoadingFrame } from "./RemoteLoadingFrame";
import { installTrustedTypesTimerCompat } from "./trusted-types-compat";

// Install during module evaluation so child effects cannot hit Trusted Types
// before the bootstrap layout effect runs.
installTrustedTypesTimerCompat();

export interface RemoteBootstrapLayoutProps {
  children: ReactNode;
  hasResolvedHostContext: boolean;
  isInsideShell: boolean;
  isWaitingForHostContext: boolean;
  loadingLabel: ReactNode;
  rootClassName: string;
  wrapStandalone?: (children: ReactNode) => ReactNode;
}

export const RemoteBootstrapLayout = ({
  children,
  hasResolvedHostContext,
  isInsideShell,
  isWaitingForHostContext,
  loadingLabel,
  rootClassName,
  wrapStandalone,
}: RemoteBootstrapLayoutProps) => {
  useEffect(() => installTrustedTypesTimerCompat(), []);

  if (isInsideShell && !hasResolvedHostContext && isWaitingForHostContext) {
    return <RemoteLoadingFrame embedded label={loadingLabel} />;
  }

  const rootContent = !isInsideShell && wrapStandalone
    ? wrapStandalone(children)
    : children;

  return <div className={rootClassName}>{rootContent}</div>;
};
